import Vue from "vue";
import { ToastPlugin, ModalPlugin } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";

import router from "./router";
import store from "./store";
import App from "./App.vue";
import "./axios";

// Global Components
import "./global-components";

// 3rd party plugins
import "@/libs/portal-vue";
import "@/libs/toastification";

import VueGtag from "vue-gtag";

import FlagIcon from "vue-flag-icon";

import SeoMixin from "./mixins/seo.js";

Vue.use(FlagIcon);

Vue.use(
    VueGtag,
    {
        config: { id: "G-H6J3WXEL9H" },
    },
    router,
);

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
    mixins: [SeoMixin],
}).$mount("#app");
